import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { UtilsService } from 'src/app/services/utils.service';
import { CandidateService } from 'src/app/services/candidate.service';
import { fromCandidateSearch } from 'src/app/reducers/candidate-search.reducer';
import { CandidateCreate } from 'src/app/models/candidate.model';
import { CustomValidators } from 'src/app/helpers/custom-validators';
import { Observable } from 'rxjs';
import { Consultant } from 'src/app/models/consultant.model';
import { fromConsultant } from 'src/app/reducers/consultant.reducer';
import { take } from 'rxjs/operators';

@Component({
  selector: 'ct-create-candidate',
  templateUrl: './create-candidate.component.html',
  styleUrls: ['./create-candidate.component.scss']
})
export class CreateCandidateComponent implements OnInit {

  consultant$: Observable<Consultant>;
  currentConsultant: Consultant;

  candidateForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    documentType: ['idCard'],
    idCard: [''],
    name: ['', [Validators.required, Validators.minLength(3), CustomValidators.validCharacters]],
    surname1: ['', [Validators.required, Validators.minLength(3), CustomValidators.validCharacters]],
    surname2: ['', [Validators.minLength(3), CustomValidators.validCharacters]]
  });

  constructor(
    private store: Store,
    private router: Router,
    private fb: FormBuilder,
    private utilsService: UtilsService,
    private candidateService: CandidateService
  ) { }

  ngOnInit(): void {
    this.consultant$ = this.store.pipe(select(fromConsultant.selectConsultantState));

    this.consultant$.subscribe(res => this.currentConsultant = res);

    this.documentTypeChange();
  }

  onSubmit() {
    this.consultant$.pipe(take(1)).subscribe(consultant => {
      this.candidateService.create([this.candidateForm.value as CandidateCreate], consultant.office.id, consultant.client.id).subscribe(
        candidate => {
          // si la fecha de creacion es de hace menos de 10 segundos es creado, si no actualizado
          if (new Date(Date.now() - 10000) < new Date(candidate[0].createdAt)) {
            this.utilsService.toast('success', 'CandidateCreated');
          } else {
            this.utilsService.toast('success', 'CandidateUpdated');
          }
          this.router.navigate(['consultant/candidates']);
        },
        error => {
          error.errorCode === 4002
            ? this.utilsService.toast('error', 'CandidateAlreadyExistsException')
            : this.utilsService.toast('error', 'CannotCreateCandidate', true, this.utilsService.getNacsData({ endpoint: 'POST AppConfig.settings.API + /candidates?origin=ct', body: this.candidateForm.value, error: { errorType: error.errorType, errorCode: error.errorCode, message: error.message } }));
        }
      );
    });
  }

  public documentTypeChange() {
    const documentTypeSelect = this.candidateForm.controls.documentType;
    const idCardInput = this.candidateForm.controls.idCard;

    idCardInput.clearValidators();

    // Validación de DNI solo para españa
    if (documentTypeSelect.value === 'idCard' && this.currentConsultant.client.id == 1) {
      if (this.currentConsultant.client.id == 1) {
        idCardInput.setValidators([CustomValidators.documentValidator, CustomValidators.validCharacters]);
      } else {
        idCardInput.setValidators([CustomValidators.validCharacters]);
      }
    } else if (documentTypeSelect.value === 'passport') {
      idCardInput.setValidators([CustomValidators.passportValidator, CustomValidators.validCharacters]);
    }

    idCardInput.setValue(idCardInput.value);

  }
}
